module.exports = __webpack_public_path__ + "static/img/7areaA_14.6911af3.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/文字バージョン/7areaA_14.png
// module id = 969
// module chunks = 1